import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, image, url }) => {
  const defaultTitle = 'PTPA - Connecting Pandikkad Expats Globally';
  const defaultDescription = 'Official website of the Pandikkad Town Pravasi Association (PTPA). Join our community, discover events, and connect with expats globally.';
  const defaultImage = `${process.env.PUBLIC_URL}/logo512.png`; // Fall back to your main logo
  const siteUrl = window.location.origin; // Dynamically grab domain

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    url: url || siteUrl,
  };

  return (
    <Helmet>
      {/* Standard SEO */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      {/* Open Graph / Facebook & WhatsApp */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};

export default SEO;
